export default __webpack_public_path__ + "static/PAPC_2022_Unibet_Sat_V1.0-62c7909adeb0b624fec668264a18e3ba.pdf";